import { bugsnagClient } from "../features/bugsnag/bugsnagClient";
import { BuildingStateType } from "./network/generated/protoTypes";
import { utilBuildings } from "./utilBuildings";
var UtilBugSnag = /** @class */ (function () {
    function UtilBugSnag() {
        this.addActionBugsnagBreadcrumb = function (action) {
            if (bugsnagClient.bugsnag != undefined) {
                bugsnagClient.bugsnag.leaveBreadcrumb("Action", action);
            }
        };
        this.addBuildingBugsnagBreadcrumb = function (building) {
            var production = building.production !== undefined ? building.production.production : undefined;
            var recipe = building.production !== undefined ? building.production.recipe : undefined;
            var bugsnagMetadata = {
                id: building.proto.id,
                name: building.balancing.name,
                productionBoosterId: production !== undefined ? production.boosterId : undefined,
                productionRecipe: recipe !== undefined ? recipe.name : undefined,
                productionState: production !== undefined
                    ? production.remainingTime === undefined
                        ? "PRODUCT_READY"
                        : "PRODUCING"
                    : undefined,
                stage: utilBuildings.getProtoStage(building),
                state: building.proto.state !== undefined
                    ? BuildingStateType[building.proto.state]
                    : undefined,
            };
            bugsnagClient.bugsnag.leaveBreadcrumb("Base Building select", bugsnagMetadata);
        };
    }
    return UtilBugSnag;
}());
export var utilBugSnag = new UtilBugSnag();



//////////////////
// WEBPACK FOOTER
// ./src/utils/utilBugSnag.ts
// module id = 823
// module chunks = 3